import {
  BRAND_ENGINE_FEATURE,
  ONLINE_ORDERING_BRAND_ENGINE_CONSUMER_FEATURE
} from 'constants/featureFlags';

export const BRAND_ENGINE_FEATURE_FLAGS = [
  BRAND_ENGINE_FEATURE,
  ONLINE_ORDERING_BRAND_ENGINE_CONSUMER_FEATURE
];

export const hasBrandEngineFeature = betaFeatureFlags =>
  BRAND_ENGINE_FEATURE_FLAGS.every(featureFlag =>
    betaFeatureFlags.includes(featureFlag)
  );
